export const DEFAULT_STOCK_IMAGE_TYPE = 'image/jpeg'
export const DEFAULT_STOCK_VIDEO_TYPE = 'video/mp4'
